import { CreditCard as BaseCreditCard } from 'types/creditCard';

type CreditCard = Pick<
  BaseCreditCard,
  'isPhysical' | 'isDefinitivelyBlocked' | 'isPremium'
>;

export function canOrderNewPhysicalCard({
  canOrderPremiumCard,
  cards,
}: {
  canOrderPremiumCard: boolean;
  cards: CreditCard[];
}) {
  const activePhysicalCards = cards.filter(
    (card) => card.isPhysical && !card.isDefinitivelyBlocked,
  );
  const hasActiveBasicPhysicalCard = activePhysicalCards.some(
    ({ isPremium }) => !isPremium,
  );
  const hasActivePremiumPhysicalCard = activePhysicalCards.some(
    ({ isPremium }) => isPremium,
  );
  const hasActivePhysicalCard =
    hasActiveBasicPhysicalCard || hasActivePremiumPhysicalCard;

  return canOrderPremiumCard
    ? !hasActivePremiumPhysicalCard
    : !hasActivePhysicalCard;
}
